module.exports = __webpack_public_path__ + "static/img/corenrDownloadTwo.3375ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/corenrDownloadTwo.png
// module id = 5rBF
// module chunks = 1